// extracted by mini-css-extract-plugin
module.exports = {"base":"style_base__qb80p","icon":"style_icon__IJDpq"};